module.exports = __webpack_public_path__ + "static/media/media-3.c01ff2e9.jpg";